module.exports = __webpack_public_path__ + "img/807e066.png";